import React from 'react'
import * as UIcons from '@iconscout/react-unicons'

const TONES = {
  active: 'bg-success bg-opacity-10 text-success',
  scheduled: 'bg-orange-500 bg-opacity-10 text-orange-500',
  completed: 'bg-body-text bg-opacity-10 text-body-text'
}

const ICONS = {
  active: UIcons.UilSync,
  scheduled: UIcons.UilCalendarAlt,
  completed: UIcons.UilCheckCircle
}

const LABELS = {
  active: 'Active',
  scheduled: 'Scheduled',
  completed: 'Completed'
}

export default function RewardAdsStatusTag({ status }) {
  const key = (status ?? '').toLowerCase()
  const Icon = ICONS[key]

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium whitespace-nowrap ${TONES[key] || TONES.completed}`}>
      {Icon && <Icon size={12} />} {LABELS[key] || status || '--'}
    </span>
  )
}
